import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const OrganizationDbnieInfoComponent = ({ onInnerFormChange, organization, currencyCodeType }: any) => (
          <>
<AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'DBNIE.Name',
                  organization?.DBNIE
                )
              }}
              type="text"
              value={organization?.DBNIE?.Name}
          />
    <InputContainer
              label="URL"
              name="URL"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'DBNIE.URL',
                  organization?.DBNIE
                )
              }}
              type="text"
              value={organization?.DBNIE?.URL}
          />
    <InputContainer
              label="Secret"
              name="Secret"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'DBNIE.Secret',
                  organization?.DBNIE
                )
              }}
              type="text"
              value={organization?.DBNIE?.Secret}
          />
      <InputContainer

              label="Active"
              name="IsActive"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event,
                  'DBNIE.IsActive',
                  organization?.DBNIE
                )
              }}
              type="checkbox"
              value={organization?.DBNIE?.IsActive}
          />
      
    
    </div>
 }
 expandedPanel="DBNIE Info"
 headerTitle="DBNIE Info"
/>
</>
)
export default OrganizationDbnieInfoComponent;
